<template>
  <div class="com-wrapper" :style="wrapperStyle">
    <div class="driver-info">
      <div v-for="(item, idx) in form" :key="idx" :class="['']" @click="handleClick(item)">
        <component
          :is="getCom(item)"
          :form-item="item || {}"
          :idx="idx"
          :omega-item="omegaItem"
          :cm="true"
          :rely-key-item="relyKeyItem(idx)"
          :hasProduct="hasProduct"
          :areaClassError="areaClassError"
          v-bind="$attrs"
          v-on="$listeners"
        ></component>
      </div>
    </div>
  </div>
</template>
<script>
import TopCity from "./top-city.vue";
import PhoneInput from "./phone-input.vue";
import TextLink from "../base/text-link-new";
import BottomSelect from "./bottom-select";

export default {
  props: ["formItem", "omegaItem", "areaClassError"],
  components: {
    TopCity,
    PhoneInput,
    TextLink
  },
  mounted() {},
  computed: {
    form() {
      return this.formItem.list || [];
    },
    wrapperStyle() {
      let selectList = this.form.filter(item => item.type === "select");
      let selectNum = selectList.length || 0;
      console.log('selectList', selectNum)
      return {
        'height': !selectNum ? '2rem' : `${selectNum * (1 + 0.32) + 2}rem`
        }
    },
    relyKeyItem() {
      return (idx) => {
        let other_key = (this.form[idx] || {}).outer_key;
        if (!other_key) {
          return null;
        } else {
          return (this.form.filter((item) => other_key === item.key) || [])[0];
        }
      };
    },
    hasProduct() {
      return (this.form || []).some(i => i.key === 'product')
    }
  },
  methods: {
    getCom(item) {
      if (item.type === "select" && item.align === "right") {
        return TopCity;
      } else {
        return {
            "phone-enter": PhoneInput,
            "text-link": TextLink,
            "select": BottomSelect,
        }[item.type];
      }
    },
    handleClick(item) {
      if (item.type === "text-link") {
        // help跳转埋点
        Omega.trackEvent("ibt_onboarding_landingpageclicktutorials_ck", "", this.omegaItem);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.com-wrapper {
  position: relative;
  height: 2.42rem;
  margin: 0 0.24rem;
  .driver-info {
    position: absolute;
    width: 100%;
    // height: 3.34rem;
    height: auto;
    top: -1.06rem;
    padding: 0.46rem 0.32rem 0.3rem;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0.06rem 0.06rem 0.3rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.12rem;
    font-size: .28rem;
    font-weight: 400;
  }
}
</style>


